<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-1" v-if="!passwordReset">
          <v-form
            ref="passwordForm"
            @submit.prevent="resetPassword"
            :errorMessages="errors.detail"
            lazy-validation
          >
            <v-card-title class="headline" primary-title
              >Reset Password</v-card-title
            >
            <v-card-text>
              <v-alert
                dense
                outlined
                type="error"
                v-if="errors.newPassword"
              >
                <ul>
                  <li v-for="error in errors.newPassword" :key="error">{{error}}</li>
                </ul>
              </v-alert>
              <v-alert
                dense
                outlined
                type="error"
                v-if="errors.token"
              >
                <ul>
                  <li v-for="error in errors.token" :key="error">{{error}}</li>
                </ul>
              </v-alert>
              <v-text-field
                v-model="password"
                id="password"
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
                :rules="passwordRules"
                :errorMessages="errors.password"
                @change="$refs.passwordForm.validate()"
              ></v-text-field>
              <v-text-field
                v-model="passwordConfirm"
                id="passwordConfirm"
                prepend-icon="mdi-lock"
                name="passwordConfirm"
                label="Confirm Password"
                type="password"
                :rules="passwordRules"
                :errorMessages="errors.password"
                @change="$refs.passwordForm.validate()"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary" text :disabled="submitted">
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        <v-card v-else>
          <v-card-title>Password Reset</v-card-title>
          <v-card-text>Please <router-link to="/login">login</router-link> with your new password to access your order dashboard.</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { resetPasswordConfirm } from "@/services/api/auth";

export default {
  name: "PasswordReset",
  props: ["uid", "token"],
  data() {
    return {
      loading: true,
      password: "",
      passwordConfirm: "",
      errors: {},
      submitted: false,
      passwordReset: false,
      passwordRules: [
        (value) => !!value || "Password is required.",
        (value) => {
          if (
            value != "" &&
            this.password != "" &&
            this.passwordConfirm != ""
          ) {
            return (
              this.password === this.passwordConfirm || "Passwords must match."
            );
          }
          return true;
        },
      ],
    };
  },
  methods: {
    resetPassword() {
      resetPasswordConfirm(this.uid, this.token, this.password)
        .then(() => {
          this.passwordReset = true;
        })
        .catch((error) => {
          this.errors = error.response.data;
        });
    },
  },
};
</script>

<style></style>
